const tracking = `
  window.dataLayer = window.dataLayer || [];
  function gtag () {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'DC-9858150');

  gtag('event', 'conversion', {
    'allow_custom_scripts': true,
    'send_to': 'DC-9858150/invmedia/medle0+unique'
  });
`;
export default tracking;



/** WEBPACK FOOTER **
 ** ./src/tag-manager/trackingActivitesPage.js
 **/